import { useTranslation } from "react-i18next";
import { resolveLanguage, SUPPORTED_LANGUAGES } from "@/src/common/locales/i18n";

export function LanguageSwitcher() {
	const { i18n, t } = useTranslation("marketing");
	const currentLang = resolveLanguage(i18n.resolvedLanguage ?? i18n.language);

	return (
		<nav
			aria-label={t("language_switcher_label")}
			className="flex items-center gap-1 rounded-full border border-white/10 bg-white/6 p-1 text-xs"
		>
			{SUPPORTED_LANGUAGES.map((lang) => {
				const isActive = lang === currentLang;
				return (
					<button
						key={lang}
						type="button"
						onClick={() => {
							if (!isActive) {
								i18n.changeLanguage(lang);
							}
						}}
						className={`rounded-full px-3 py-1 font-semibold uppercase tracking-[0.2em] transition-colors ${
							isActive ? "bg-white/14 text-white" : "text-white/56 hover:text-white"
						}`}
						aria-pressed={isActive}
					>
						{lang}
					</button>
				);
			})}
		</nav>
	);
}
